<div
  class="w-full h-[500px] flex justify-center items-center"
  [ngClass]="{ 'h-[500px]': !smallLoader, 'h-[50px]': smallLoader }"
>
  <app-loader-hashtag></app-loader-hashtag>
</div>
